import * as yup from 'yup'
import { SYSTEM_MESSAGE_IDS } from 'src/app/shared/constants/systemMessages.constants'
import { PatternValidate } from 'src/app/shared/utils'
import { EXPIRATION_TYPE } from './constants'
import { DURATION_EXPIRES } from 'src/app/shared/constants/common.constants'

function generateValidationSchema(t: any) {
  const validationSchema = yup
    .object()
    .shape({
      roleName: yup
        .string()
        .trim()
        .required(t('SystemMessages:' + SYSTEM_MESSAGE_IDS.ROLE_NAME_REQUIRED)),
    })
    .when((values: any, schema) => {
      let schemaUpdated = {}
      if (values[0]?.navigationOptions?.length === 0) {
        schemaUpdated = {
          navigationOptions: yup
            .array()
            .min(1, t('SystemMessages:' + SYSTEM_MESSAGE_IDS.AL_LEAST_ONE_NAVIGATION_OPTION)),
        }
      }

      if (values[0].expirations === EXPIRATION_TYPE.EXPIRE_X_MINUTES) {
        schemaUpdated = {
          ...schemaUpdated,
          ...{
            expirationMinutes: yup
              .number()
              .required(
                t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
                  Required_Field: `${t('UserRoles:durationExpiresInMinutes')}`,
                }),
              )
              .min(1, t('SystemMessages:' + SYSTEM_MESSAGE_IDS.POSITIVE_NUMBER))
              .max(DURATION_EXPIRES, t('SystemMessages:' + SYSTEM_MESSAGE_IDS.POSITIVE_NUMBER))
              .transform((value) => (Number.isNaN(value) ? null : value))
              .test('isNumber', t('SystemMessages:' + SYSTEM_MESSAGE_IDS.INVALID_VALUE_IN_NUMBER_FIELD), (value) => {
                return PatternValidate.numberOnlyPattern.test(value.toString())
              }),
          },
        }
      }

      if (values[0].expirations === EXPIRATION_TYPE.EXPIRE_X_DAYS) {
        schemaUpdated = {
          ...schemaUpdated,
          ...{
            expirationDays: yup
              .number()
              .required(
                t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
                  Required_Field: `${t('UserRoles:durationExpiresInDays')}`,
                }),
              )
              .min(1, t('SystemMessages:' + SYSTEM_MESSAGE_IDS.POSITIVE_NUMBER))
              .max(DURATION_EXPIRES, t('SystemMessages:' + SYSTEM_MESSAGE_IDS.POSITIVE_NUMBER))
              .transform((value) => (Number.isNaN(value) ? null : value))
              .test('isNumber', t('SystemMessages:' + SYSTEM_MESSAGE_IDS.INVALID_VALUE_IN_NUMBER_FIELD), (value) => {
                return PatternValidate.numberOnlyPattern.test(value.toString())
              }),
          },
        }
      }

      return schema.shape(schemaUpdated)
    })

  return validationSchema
}

export { generateValidationSchema }
